import * as React from 'react';
import {
  useVwFeatureService,
  VwFeatureServiceIds,
} from '@volkswagen-onehub/vw-e-mobility-feature-app-commons';
import {ArrowRight} from '@volkswagen-onehub/icons-core';
import {ConfigureButtonProps} from '@volkswagen-onehub/whitelabel-e-mobility-commons';
import {Button} from '../button';

export const ConfigureButton = ({
  category,
  carlineId,
  salesGroupId,
  trimName,
  label,
  ariaLabel,
  handleTracking,
}: ConfigureButtonProps): JSX.Element => {
  const singleConfigurationFlowNavigator = useVwFeatureService(
    VwFeatureServiceIds.singleConfigurationFlowNavigator
  );

  const configureNavigation =
    singleConfigurationFlowNavigator.createConfigureNavigation({
      category,
      carlineId,
      salesGroupId,
      trimName,
    })!;

  const {href, onClick} = configureNavigation;

  const handleOnClick = () => {
    onClick();
    if (handleTracking) handleTracking(href);
  };

  return (
    <Button
      tag="a"
      emphasis="secondary"
      href={href}
      onClick={handleOnClick}
      iconPosition={'end'}
      icon={<ArrowRight variant="default" ariaHidden />}
      ariaLabel={ariaLabel}
    >
      {label}
    </Button>
  );
};
